<div class="wrapper">
    <router-outlet></router-outlet>
</div>
<app-designer-tour></app-designer-tour>
<app-ai-support-chat *ngIf="!isAdminPage"></app-ai-support-chat>
